import { Center, Spinner } from '@omnipresentgroup/design-system';

export const Loading = () => (
  <Center.Absolute>
    <Spinner size="40" />
  </Center.Absolute>
);

export default Loading;
